// conductor-emit-hash: 688311db
// generated by pbo-conductor — 주문수집 (gl02)
// conductor-build: f2f3fe48 2026-09-21T22:23:26.708Z · pbo-core 0.8.2
// dev 위치: pages/global/orderCollect
// 데이터 seam: useGlobalOrderCollect — TODO(dev): 목데이터를 이 훅으로 교체
//
// 그룹 규격 — 이 화면이 쓰는 공통 조합의 계약(컨덕터 소유).
//   이 값을 벗어나면 컨덕터 데모와 어긋납니다. 규격을 바꾸려면 컨덕터에서 바꾸세요.
//   ⚠️ 그룹은 화면마다 사본으로 나갑니다 — 여기서 고쳐도 다른 화면은 바뀌지 않습니다.
//   titleRow #0d760c
//     · title(제목) — 자유 입력
//     · backRoute(뒤로가기 라우트) — 자유 입력
//     · notice(제목 옆 안내 문구) — 자유 입력
//     · stickyTop(스티키 멈춤 위치(px)) 제한 없음 [기본 12]
//     · buttonSize(타이틀 버튼 크기) = S | M | L [기본 L]
//     · 제목 옆 컨트롤과 우측 액션은 자리를 섞지 않는다 — 컨텍스트(센터·뷰)는 제목 옆, 행위는 우측 끝
//
import { core } from '@musinsa/pbo-core'
import { pboLogisticsTheme } from '@musinsa/pbo-core/theme'
import '@musinsa/pbo-core/tokens.css'
import '@musinsa/pbo-core/styles.css'
import '@musinsa/pbo-core/fonts.css'
import '../screenShell.css'
import { useEffect, useRef, useState } from 'react'
import { PlusOutlined } from '@ant-design/icons'
import dayjs, { type Dayjs } from 'dayjs'
import { usePageHeaderSticky } from '../pageHeaderSticky'
import type { ButtonCode, ToolbarConfig } from '@/services/auth/menu.types'

// 컴포넌트 모드(문서 51) — 이 파일은 겉(UI)만이다. 배선(Wiring)은 화면 엔트리(개발자 소유)가 props 로 넘긴다 — 옛 훅·API·핸들러를 그대로 쓰면 된다.
//  모듈 홀더: 확인창 함수·선택 게이트 등 모듈 수준 코드가 같은 배선을 보도록 렌더 첫머리에서 갱신한다. props.wiring 은 렌더마다 새 객체여도 된다(효과 의존성에 쓰지 않는다).
let wiring: Wiring = { rows: {}, actions: {} } as Wiring
// 버튼 권한 슬롯(LOGISPRD-16733) — 슬롯이 없으면 전부 보이고 편집된다.
const permCan = (code: ButtonCode) => wiring.permission?.canShow(code) ?? true

/** 배선 계약(문서 50) — wiring.ts(개발자 소유)가 이 타입을 채운다. 이름은 노드 id·상수명에서 기계적으로 나온다.
 *  화면(이 파일)은 재핸드오프 때 통째로 덮어쓴다 — 계약이 바뀌면 dev tsc 가 wiring.ts 의 그 자리를 가리킨다. */
export type Row = Record<string, unknown>
/** 표 슬롯 인자 — filters = 같은 화면 조회영역 값(키 = filterKey/노드 id) · pager = 액션바 페이저(page 1부터, size). 없는 화면은 undefined. */
export type RowsQuery = { filters?: Record<string, unknown>; pager?: { page: number; size: number } }
/** 액션 슬롯 인자 — selected = 같은 core.TableSelectionScope 안 표의 선택 행(체크박스). 선택 표가 없는 화면은 빈 배열. */
export type ActionCtx = { selected: Row[]; visible?: Row[]; form?: FormState } // selected = 체크 선택 행 · visible = 목록 검색 뒤 화면에 보이는 행(표가 여럿이면 마지막 표, 검색칸 없는 화면은 없음) · form = 확인을 누른 모달의 폼 값(폼 스토어가 있는 모달만)
/** 폼 버스 상태(모달·카드의 입력 값). 조건(hideWhen 등)은 wiring.form.<store> 가 덮어쓴 유효 상태를 본다. */
export type FormState = Record<string, unknown>
/** 선택지(옵션) — value 는 API/코드 값, label 은 표시 문구. 조회영역·모달 셀렉트/라디오는 숫자 value 도 쓴다. */
export type Option = { value: string | number; label: string }
/** 편집 셀 셀렉트의 선택지 — DS 셀 계약(variantProps.options)이 value 를 문자열로만 받는다. */
export type CellOption = { value: string; label: string }
export type Wiring = {
  /** 표 데이터 — 인자는 데모 목데이터(자리 표시)와 조회 조건·페이저. 컴포넌트 본문 첫머리에서 항상 같은 순서로 불리므로 안에서 조회 훅을 써도 된다.
   *  배열을 돌려주면 클라이언트 페이징(데모와 같음), { rows, total } 을 돌려주면 서버 페이징(표는 그대로 그리고 카운트·페이저는 total). */
  rows: Record<never, never>
  /** 동작 — 조회(search)·버튼·확인창·모달 확인·편집 셀·행 버튼. 실패는 throw(확인창·모달이 열린 채 남는다). 성공 토스트·닫기는 생성본이 한다. */
  actions: { gl02CollectButton: (ctx: ActionCtx) => void | string | false | Promise<void | string | false> }
  /** 요청 진행 중 여부(React 훅) — true 면 선택 게이트 버튼(확정·삭제·저장 등)이 잠긴다. 선택 게이트 버튼이 매 렌더 부르므로 안에서 훅을 써도 된다(예: react-query useIsMutating() > 0). 없으면 잠그지 않는다. */
  useBusy?: () => boolean
  /** 표 체크 선택이 바뀔 때 — 상세 표가 선택을 따라가는 화면(마스터-디테일)에서 배선이 그 키로 상세를 조회한다.
   *  선택이 있는 스코프만 알린다(위아래 표에서 빈 스코프가 덮지 않게). 액션 슬롯의 ctx.selected 와 같은 값이다.
   *  scope = **그 선택이 어느 표 그룹의 것인지**(그룹 노드 id). 위아래 표가 있는 화면은 이것으로 갈라 둔다 —
   *  선택을 **푼** 신호는 rows 가 빈 배열이라 행만 보고는 어느 표인지 알 수 없다(2026-09-21 est01). */
  onSelect?: (rows: Row[], scope: string) => void
  /** 버튼 권한(LOGISPRD-16733) — 메뉴 API 의 버튼 권한 계산 결과. 없으면 전부 보이고 편집된다(지금 동작).
   *  canShow = code 가 붙은 버튼 노출 · toolbar = 엑셀 업로드·다운로드 등 툴바 버튼 · editable = false 면 [일괄 입력]을 숨긴다 ·
   *  columns = 표 컬럼(잠금이면 편집 셀을 글자로 바꿔 돌려준다 — 채우기·Delete·타이핑도 함께 막힌다). */
  permission?: { canShow: (code: ButtonCode) => boolean; toolbar: ToolbarConfig; editable: boolean; columns: (columns: core.CoreColumnType[]) => core.CoreColumnType[] }
}

// 선택 행 브리지 — 액션 슬롯 인자(ctx.selected). 같은 core.TableSelectionScope 안 표의 체크 선택 행(SelBridge 가 채운다). 한 화면에 스코프가 여럿이면 마지막으로 바뀐 스코프의 선택이다.
const selRef: { current: Record<string, unknown>[] } = { current: [] }
const selCtx = (): ActionCtx => ({ selected: selRef.current })

const POPUP_DOWN = {
  bottomLeft: { points: ['tl', 'bl'], offset: [0, 4], overflow: { adjustX: true, adjustY: false } },
  bottomRight: { points: ['tr', 'br'], offset: [0, 4], overflow: { adjustX: true, adjustY: false } },
}

/** 기본 기간 프리셋 → ['YYYY-MM-DD','YYYY-MM-DD']. periodBase 'futureTo' = 오늘~+N(입고예정일 등) / 'pastTo' = -N~오늘. */
const presetRange = (preset?: string, periodBase: 'futureTo' | 'pastTo' = 'futureTo'): [string, string] | undefined => {
  if (!preset) return undefined
  const now = dayjs()
  const n = preset === 'today' ? [0, 'day'] : preset === 'week' ? [6, 'day'] : preset === 'month' ? [1, 'month'] : preset === 'month3' ? [3, 'month'] : preset === 'month6' ? [6, 'month'] : null
  if (!n) return undefined
  const other = periodBase === 'futureTo' ? now.add(n[0] as number, n[1] as 'day' | 'month') : now.subtract(n[0] as number, n[1] as 'day' | 'month')
  const [a, b] = periodBase === 'futureTo' ? [now, other] : [other, now]
  return [a.format('YYYY-MM-DD'), b.format('YYYY-MM-DD')]
}

const toDayjsPair = (v: unknown): [Dayjs, Dayjs] | null => (Array.isArray(v) && v[0] && v[1] ? [dayjs(String(v[0])), dayjs(String(v[1]))] : null)

/** 다건 코드 입력 — 인풋 + 우측 [+] 팝오버 textarea(Enter 로 다중 입력, 최대 `limit` — 기본 1,500). 규격 = .pbo-filter-code*
 *  구분자는 인풋·팝오버 모두 쉼표·공백·줄바꿈(1.0 코드 입력 동치 — 같은 문자열이 두 경로에서 다르게 해석되지 않게).
 *  한도는 자르지 않는다 — 초과분을 그대로 내보내 화면의 한도 경고가 살아 있게 한다(잘라 내면 앞 N개만 조용히 조회된다, moms-fe #739 Critical 2026-09-11). */
function MultiCodeInput({ value, onChange, placeholder, limit = 1500 }: { value: string[]; onChange: (v: string[]) => void; placeholder?: string; limit?: number }) {
  const [open, setOpen] = useState(false)
  // 편집 원문 두 벌(인풋=쉼표·팝오버=줄) — 밖으로 내는 배열만 정규화한다. 입력마다 정규화해 되돌려 쓰면 끝의 구분자가 즉시 지워진다.
  const [text, setText] = useState(value.join('\n'))
  const [line, setLine] = useState(value.join(', '))
  const wrapRef = useRef<HTMLDivElement>(null)
  const joined = value.join('\n')
  const normalize = (raw: string, splitBy: RegExp) => Array.from(new Set(raw.split(splitBy).map((s) => s.trim()).filter(Boolean)))
  const shown = normalize(text, /[\s,]+/)
  // 밖에서 값이 바뀌었을 때만(초기화·복원) 원문을 따라간다 — 내 입력이 만든 값이면 원문(끝의 구분자 포함)을 보존한다.
  const lastEmit = useRef(joined)
  useEffect(() => {
    if (joined === lastEmit.current) return
    lastEmit.current = joined
    setText(joined)
    setLine(value.join(', '))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [joined])
  const emit = (arr: string[]) => {
    lastEmit.current = arr.join('\n')
    onChange(arr)
  }
  const onLine = (raw: string) => {
    setLine(raw)
    const arr = normalize(raw, /[\s,]+/)
    setText(arr.join('\n'))
    emit(arr)
  }
  const onText = (raw: string) => {
    setText(raw)
    const arr = normalize(raw, /[\s,]+/)
    setLine(arr.join(', '))
    emit(arr)
  }
  useEffect(() => {
    if (!open) return
    const onDown = (e: MouseEvent) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target as Node)) setOpen(false)
    }
    window.addEventListener('mousedown', onDown)
    return () => window.removeEventListener('mousedown', onDown)
  }, [open])
  return (
    <div className="pbo-filter-code" ref={wrapRef} style={{ position: 'relative', width: '100%' }}>
      <core.Input
        placeholder={placeholder ?? '다건 입력 시, 우측 + 버튼을 눌러주세요.'}
        value={line}
        onChange={(e) => onLine(e.target.value)}
        suffix={<PlusOutlined style={{ color: 'rgba(0, 0, 0, 0.45)', fontSize: 14, cursor: 'pointer' }} onMouseDown={(e) => e.preventDefault()} onClick={(e) => { e.stopPropagation(); setOpen(true) }} />}
      />
      {open && (
        <div className="pbo-filter-code-pop">
          <core.Input.TextArea
            value={text}
            placeholder="입력 후 Enter 키로 다중 입력이 가능합니다."
            onChange={(e) => onText(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter' && shown.length >= limit) e.preventDefault() }}
            autoSize={{ minRows: 4, maxRows: 16 }}
            autoFocus
          />
          <div className="pbo-filter-code-foot">
            <span style={{ fontSize: 12, color: shown.length > limit ? '#ff4d4f' : '#8c8c8c' }}>{shown.length} / {limit.toLocaleString()}</span>
            <core.Button size="small" onClick={() => onText('')}>
              초기화
            </core.Button>
          </div>
        </div>
      )}
    </div>
  )
}

/** 기간 필드 — [기간유형 셀렉트 120 고정] + 레인지피커(프리셋 태그·'오늘/최근 N개월' 푸터·maxRangeDays·periodBase·좁으면 MM-DD). 값 = ['YYYY-MM-DD','YYYY-MM-DD']. */
function DateRangeField({ value, onChange, defaultPeriod, periodBase = 'futureTo', maxRangeDays, hidePresets, typeOptions, format = 'YY-MM-DD' }: { value?: [string, string]; onChange: (v: [string, string] | undefined) => void; defaultPeriod?: string; periodBase?: 'futureTo' | 'pastTo'; maxRangeDays?: number; hidePresets?: boolean; typeOptions?: Option[]; format?: string }) {
  const TAG: Record<string, string> = { today: '오늘', week: '일주일', month: '1개월', month3: '3개월', month6: '6개월' }
  const def = presetRange(defaultPeriod, periodBase)
  // 값이 비면(진입·초기화) 기본 기간으로 되돌려 보고한다 — 조회 조건에도 기본 기간이 걸린다.
  useEffect(() => {
    if (!value && def) onChange(def)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])
  // 프리셋 태그는 **현재 값**에서 유도한다 — 조회영역을 접었다 펴면 이 컴포넌트가 리마운트되는데, 기본 프리셋으로 초기화하면
  //  실제 기간이 달라도 태그가 '오늘' 로 돌아간다(moms-fe #738 리뷰 2026-09-11). 값이 프리셋과 일치할 때만 태그를 단다.
  const tagOf = (v?: [string, string]): string | null => {
    if (!v) return (defaultPeriod && TAG[defaultPeriod]) ?? null
    const hit = Object.keys(TAG).find((k) => { const r = presetRange(k, periodBase); return !!r && r[0] === v[0] && r[1] === v[1] })
    return hit ? TAG[hit] : null
  }
  const [tag, setTag] = useState<string | null>(() => tagOf(value))
  const [selected, setSelected] = useState(0)
  const [open, setOpen] = useState(false)
  const [epoch, setEpoch] = useState(0)
  const [panel, setPanel] = useState<'date' | 'month' | 'year'>('date')
  const rootRef = useRef<HTMLDivElement>(null)
  const [compact, setCompact] = useState(false)
  useEffect(() => {
    const el = rootRef.current
    if (!el || !typeOptions?.length) return
    const ro = new ResizeObserver(() => setCompact(el.clientWidth > 0 && el.clientWidth < 260))
    ro.observe(el)
    return () => ro.disconnect()
  }, [typeOptions])
  const apply = (next: [Dayjs, Dayjs], label: string, months: number) => {
    onChange([next[0].format('YYYY-MM-DD'), next[1].format('YYYY-MM-DD')])
    setSelected(months)
    setTag(label)
    setOpen(false)
    setEpoch((e) => e + 1)
  }
  const picker = (
    <core.DatePicker.RangePicker placement="bottomLeft" {...({ builtinPlacements: POPUP_DOWN } as object)}
      key={`${epoch}-${compact ? 'c' : 'f'}`}
      className={typeOptions?.length ? 'pbo-filter-picker' : 'pbo-filter-picker pbo-filter-picker-full'}
      allowClear={false}
      format={compact ? 'MM-DD' : format}
      placeholder={['시작일', '종료일']}
      value={toDayjsPair(value ?? def)}
      open={open}
      onOpenChange={setOpen}
      onPanelChange={(_v, modes) => setPanel(((modes as string[]).find((x) => x !== 'date') as 'month' | 'year' | undefined) ?? 'date')}
      prefix={tag ? <core.Tag className="pbo-filter-date-tag" color="default" style={{ marginInlineEnd: 4 }}>{tag}</core.Tag> : undefined}
      onChange={(vals) => {
        setSelected(0)
        setTag(vals && vals[0] && vals[1] ? '직접' : null)
        onChange(vals && vals[0] && vals[1] ? [vals[0].format('YYYY-MM-DD'), vals[1].format('YYYY-MM-DD')] : undefined)
      }}
      disabledDate={(current, info) => {
        if (periodBase === 'pastTo' && current.isAfter(dayjs(), 'day')) return true
        if (maxRangeDays && info?.from && Math.abs(current.diff(info.from, 'days')) > maxRangeDays - 1) return true
        return false
      }}
      renderExtraFooter={
        hidePresets
          ? undefined
          : () => (
              <div className={`pbo-filter-date-footer ${panel}`}>
                <core.Button type="link" onClick={() => apply([dayjs(), dayjs()], '오늘', 0)}>
                  오늘
                </core.Button>
                <div className="pbo-filter-date-presets">
                  <span>{periodBase === 'pastTo' ? '최근' : '오늘부터'}</span>
                  {[1, 2, 3, 6].map((m) => (
                    <core.Button key={m} className={m === selected ? 'selected' : undefined} onClick={() => apply(periodBase === 'pastTo' ? [dayjs().subtract(m, 'month'), dayjs()] : [dayjs(), dayjs().add(m, 'month')], `${m}개월`, m)}>
                      {m}개월
                    </core.Button>
                  ))}
                </div>
              </div>
            )
      }
      style={{ width: '100%' }}
    />
  )
  if (!typeOptions?.length) return picker
  return (
    <div className="pbo-filter-date pbo-filter-row" ref={rootRef}>
      <core.Select placement="bottomLeft" builtinPlacements={POPUP_DOWN} className="pbo-filter-type" options={typeOptions} defaultValue={typeOptions[0]?.value} popupMatchSelectWidth={false} />
      {picker}
    </div>
  )
}

export default function GlobalOrderCollectPageView(props: { wiring: Wiring }) {
  wiring = props.wiring // 모듈 홀더 갱신 — 렌더마다 같은 참조
  const hdrgl02Title_titleRowDef = usePageHeaderSticky()
  const [collectPeriod, setCollectPeriod] = useState<[string, string]>(() => [dayjs().subtract(1, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')])
  const [orderNos, setOrderNos] = useState<string[]>([])
  const [lastDeliveryItemIds, setLastDeliveryItemIds] = useState<string[]>([])
  const busy = wiring.useBusy?.() ?? false
  useEffect(() => { document.body.classList.add('pbo-screen-portal'); return () => { document.body.classList.remove('pbo-screen-portal') } }, [])
  return (
    <core.ConfigProvider theme={pboLogisticsTheme}>
      <div className="pbo-core-screen pbo-screen-shell pbo-fonts">
        {/* #globalOrderCollect GlobalOrderCollectPage */}
        <core.Flex vertical gap={16} align="stretch">
          {/* #workspaceTab WorkspaceTab */}
          <core.WorkspaceTab style={{ margin: "-24px -24px 0px -24px" }} activeLabel="주문수집" />
          {/* ▼ 그룹 cmp.TitleRow #gl02Title — 구조·배치는 컨덕터 그룹 정의 소유(파일 머리 '그룹 규격'). 안의 요소를 다른 조합(DS 옛 통짜 포함)으로 바꾸지 말고 배선만 붙인다 */}
          {/* #gl02Title:titleRowDef TitleRow */}
          <core.Flex gap={8} justify="space-between" align="center" ref={hdrgl02Title_titleRowDef.ref} className={`dev-page-header-wrap pin${hdrgl02Title_titleRowDef.isSticky ? ' sticky' : ''}`} style={{ flexDirection: "row", justifyContent: "space-between", alignItems: "center", height: 'auto', minHeight: 40, top: 'calc(12px - var(--pbo-page-header-scroller-pad, 0px))', ['--pbo-page-header-bleed-top' as string]: '36px' }}>
            {/* #gl02Title:pageTitle PageTitle */}
            <core.Typography.Title level={4} style={{ margin: 0, whiteSpace: 'pre-line' }}>주문수집</core.Typography.Title>
            {/* #gl02Title:titleRight TitleRight */}
            <core.Flex gap={16} align="center">{null}</core.Flex>
          </core.Flex>
          {/* ▲ 그룹 cmp.TitleRow #gl02Title 끝 */}
          {/* #gl02FormCard CollectFormCard */}
          <core.Flex style={{ width: 468, padding: "16px 16px 16px 16px", borderWidth: "1px 1px 1px 1px", borderColor: "#d9d9d9", borderRadius: 8, borderStyle: "solid" }} vertical gap={16} align="stretch">
            {/* #gl02Form CollectForm */}
            <core.Form layout="horizontal">
              {/* #gl02PeriodItem PeriodItem */}
              <core.FormItem label="수집기간" required labelWidth={112}>
                {/* #gl02Period PeriodPicker */}
                <div className="pbo-filter-control" style={{ width: 312 }}>
                  <DateRangeField value={collectPeriod} onChange={(value) => value && setCollectPeriod(value)} periodBase="pastTo" />
                </div>
              </core.FormItem>
              {/* #gl02OrderNosItem OrderNosItem */}
              <core.FormItem label="주문번호" required labelWidth={112}>
                <div className="pbo-filter-control" style={{ width: 312 }}>
                  <MultiCodeInput value={orderNos} onChange={setOrderNos} placeholder="주문번호를 입력해 주세요." limit={200} />
                </div>
              </core.FormItem>
              {/* #gl02LimitItem LimitItem */}
              <core.FormItem label="제한" labelWidth={112}>
                {/* #gl02Limit LimitInput */}
                <core.Input placeholder="제한을(를) 입력해 주세요." style={{ width: 312 }} />
              </core.FormItem>
              {/* #gl02LastDeliveryItem LastDeliveryItem */}
              <core.FormItem label="마지막 배송 번호" labelWidth={112}>
                {/* #gl02LastDelivery LastDeliveryInput */}
                <div className="pbo-filter-control" style={{ width: 312 }}>
                  <MultiCodeInput value={lastDeliveryItemIds} onChange={setLastDeliveryItemIds} placeholder="마지막 배송 번호를 입력해 주세요." limit={1} />
                </div>
              </core.FormItem>
            </core.Form>
            {/* #gl02Actions CollectActions */}
            <core.Flex gap={8} justify="flex-end" align="center">
              {/* #gl02CollectButton CollectButton */}
              {permCan('COLLECT') && <core.Button type="primary" loading={busy} disabled={busy} onClick={() => { const okMsg = "수집되었습니다."; Promise.resolve(wiring.actions.gl02CollectButton(selCtx())).then((r) => { if (r !== false) core.message.success(typeof r === 'string' ? r : okMsg); }, () => undefined) }}>{busy ? '수집 중' : '수집'}</core.Button>}
            </core.Flex>
          </core.Flex>
        </core.Flex>
      </div>
    </core.ConfigProvider>
  )
}
